/* eslint-disable @typescript-eslint/no-var-requires */
/**
 * global.ts 会在app.ts之前运行
 */
import Aegis from 'aegis-web-sdk';
import { initToken } from '@/utils/token';
import { getUrlLocation } from '@/utils/location';
import {
  isInZhuYingTai,
  isInWechat,
  isInZhuzher,
  isProduction,
} from '@/utils/env';
import '@/styles/classes/_base.less';
import '@/styles/classes/_loop.less';
import '@/styles/overrides.less';
import { initOriginUrl } from './utils/log/logWithOriginUrl';
import 'antd-mobile-v2/dist/antd-mobile.less';
import { initCacheProjectInfo } from './utils/cacheProjectCode';
import LocalStorageInSession from './utils/localStorageInSession';
import { logStorage } from './utils/log';

require('amfe-flexible');

// 初始化Token
initToken();

// 初始化标记参数，缓存url数据
initOriginUrl();

// 初始化全局会话数据
LocalStorageInSession.init(logStorage.store.globalInfo?.sessionId as string);

// 缓存住这儿projectCode信息到内存
initCacheProjectInfo();

// 获取url上面的位置信息
getUrlLocation();
// 初始化调试工具，生产会关闭
// 这里会经过webpack编译忽略, 所以需要使用CMD的写法
if (
  (process.env.NODE_ENV === 'production' &&
    process.env.UMI_ENV === 'staging') ||
  process.env.NODE_ENV !== 'production'
) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  // eslint-disable-next-line global-require
  const VConsole = require('vconsole');
  if (isInZhuzher || isInWechat || isInZhuYingTai) {
    // eslint-disable-next-line no-new
    new VConsole();
  }
}

if (isProduction) {
  if (Aegis) {
    const is4xxStatusCode = (status: string) => {
      const regex = /^4\d{2}$/;
      return regex.test(status);
    };
    const initRUM = () => {
      return new Aegis({
        id: 'O5KgXTQpgZ6rXbqxwe', // 上报 id
        // uin: res?.data?.id || 'xxx', // 用户唯一 ID（可选）
        reportApiSpeed: true, // 接口测速
        reportAssetSpeed: false, // 静态资源测速
        spa: false, // spa 应用页面跳转的时候开启 pv 计算
        hostUrl: 'https://rumt-zh.com',
        beforeReportSpeed(msg: any) {
          // 过滤4xx状态码
          return !is4xxStatusCode(msg.status);
        },
        beforeRequest(data: any) {
          const filterWord = 'Script error';
          //  过滤特殊跨域报错信息：Script error
          if (
            data.logType === 'log' &&
            data.logs.msg.indexOf(filterWord) > -1
          ) {
            return false;
          }
          return data;
        },
      });
    };
    initRUM();
  }
}
